import { render, staticRenderFns } from "./PaginationControl.vue?vue&type=template&id=c4252c8a&scoped=true"
import script from "./PaginationControl.vue?vue&type=script&lang=js"
export * from "./PaginationControl.vue?vue&type=script&lang=js"
import style0 from "./PaginationControl.vue?vue&type=style&index=0&id=c4252c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4252c8a",
  null
  
)

export default component.exports